// @flow
import Cookies from "js-cookie"
import * as MODALS from "@kiwicom/nitro/lib/consts/modals"
import type { Modal } from "@kiwicom/nitro/lib/consts/modals"

import * as user from "common/services/user"

const SIDENAV_OPENED_CLASS = "sidenav-opened"
const REACT_VIEW_MODAL_ATTR = "inert"
const RECENT_SEARCH_REDIRECT_COOKIE = "recentRedirect"
const MOBILE_FIXED = "_mobile-fixed"

export const modals = (modal: Modal) => {
  const body = document.querySelector("body")
  const viewEl = document.getElementById("react-view")
  const mainView = document.querySelector(".MainView")

  const store = window.reduxStore // oh fuck I am sorry :(

  if (body) {
    if (modal === MODALS.SIDE_NAV) {
      body.classList.add(SIDENAV_OPENED_CLASS)
    } else {
      body.classList.remove(SIDENAV_OPENED_CLASS)
    }
  }

  if (mainView) {
    if (modal === MODALS.SIGN_IN || modal === MODALS.REGISTER || modal === MODALS.MY_BOOKING) {
      store.dispatch(user.resetError())
      mainView.classList.add(MOBILE_FIXED)
    } else {
      mainView.classList.remove(MOBILE_FIXED)
    }
  }

  if (viewEl) {
    if (modal === MODALS.NONE) {
      viewEl.removeAttribute(REACT_VIEW_MODAL_ATTR)
    } else if (![MODALS.CURRENCY_MENU, MODALS.LANGUAGE_MENU, MODALS.MY_BOOKING].includes(modal)) {
      viewEl.setAttribute(REACT_VIEW_MODAL_ATTR, "true")
    }
  }
}

export const logoClick = () => {
  Cookies.remove(RECENT_SEARCH_REDIRECT_COOKIE)
}
